import { useScrollReveal } from '@/hooks/useScrollReveal';

const lines = [
  { id: "executing-twelve", text: "You\u2019re executing on twelve things because you can\u2019t tell which three actually matter." },
  { id: "list-grew", text: "Every morning starts with a list that grew overnight. You finish the day having worked hard on things that didn\u2019t move the number." },
  { id: "misaligned", text: "You\u2019ve hired people, launched campaigns, built systems \u2014 and something still feels misaligned but you can\u2019t name it." },
  { id: "pitch-deck", text: "The pitch deck says one thing. The product says another. Your cofounder\u2019s priorities say a third." },
  { id: "decision-layer", text: "You\u2019re not failing. You\u2019re operating without a decision layer." },
];

const Problem = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="problem-section"
      className={`section-reveal ${isVisible ? 'visible' : ''}`}
      style={{ backgroundColor: '#3A3D42' }}
    >
      <div className="content-narrow">
        {lines.map((line, i) => (
          <p key={line.id} className="problem-line" data-testid={`problem-line-${i}`}>
            {line.text}
          </p>
        ))}
      </div>
    </section>
  );
};

export default Problem;
